import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CertificateNote_Interface, Empty_CertificateNote_Interface } from 'src/app/Interface/CertificateNote_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CertificateNoteService } from 'src/app/Service/CertificateNote/CertificateNote.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CertificateNoteList',
  templateUrl: './CertificateNoteList.component.html',
  styleUrls: ['./CertificateNoteList.component.scss']
})
export class CertificateNoteListComponent implements OnInit {
  Filter_code:string=""
  Filter_dsc:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private CertificateNote_Service:CertificateNoteService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_CertificateNote:Array<CertificateNote_Interface>=[]
  Data_Seleted_Delete:CertificateNote_Interface=Empty_CertificateNote_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(2212).subscribe(
      data=>{
        this.ReadData_CertificateNote()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

    
  }

  ReadData_CertificateNote(){
    this.Procssing=true
    this.CertificateNote_Service.GetRecord().subscribe(
      data=>{
        this.DataList_CertificateNote=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:CertificateNote_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.CertificateNote_Service.DeleteCertificateNote(item.id).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_CertificateNote()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
